import Vue from 'vue'
import dayjs from 'dayjs'

Vue.filter('showFullPriceFormat', (number) => {
  if (!number && number !== 0) return '-'
  const num = parseFloat(number)
  if (num === 0 || num) {
    return parseFloat(num).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return '-'
})

Vue.filter('showNumberFormat', (number, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  if (!number && number !== 0) return '-'
  const num = parseFloat(number)

  return num
    .toLocaleString('en-US', {
      minimumFractionDigits,
      maximumFractionDigits
    })
    .replace(/\.00$/, '')
})
Vue.filter('paddingNumber', (number = 0) => {
  const strNumber = number.toString()
  return strNumber.length <= 5 ? strNumber.padStart(5, '0') : strNumber.padStart(strNumber.length, '0')
})

Vue.filter('toCapitalize', (text) => {
  if (!text) {
    return '-'
  }

  return text.replace(/[a-z]/, (w) => w.toUpperCase())
})

Vue.filter('dateFormat', (date) => (date ? dayjs(date).format('YYYY-MM-DD') : '-'))

Vue.filter('dateTimeFormat', (date) => (date ? dayjs(date).format('YYYY-MM-DD HH:mm') : '-'))

Vue.filter('dateUserFormat', (date) => (date ? dayjs(date).format('DD/MM/YYYY') : '-'))

Vue.filter('salesDateInLocalTimeZone', (date) => (date ? dayjs(date).subtract(7, 'hour').format('DD/MM/YYYY') : '-'))

Vue.filter('dateUserFormatMonth', (date) => (date ? dayjs(date).format('DD MMM YYYY') : '-'))

Vue.filter('dateTimeUserFormat', (date) => (date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '-'))
